(function () {
  function initNecklaceLp(section) {
    if (!section || section.__lpNecklaceInited) return;
    section.__lpNecklaceInited = true;

    var finishLabel = section.querySelector('[data-lp-finish-selected]');
    function updateFinishLabel() {
      if (!finishLabel) return;
      var active = section.querySelector('[data-lp-finish-selector] .pendant-btn.active');
      if (active) finishLabel.textContent = active.getAttribute('data-lp-option-value') || active.textContent.trim();
    }
    section.querySelectorAll('[data-lp-finish-selector] .pendant-btn').forEach(function (button) {
      button.addEventListener('click', function () {
        window.setTimeout(updateFinishLabel, 0);
      });
    });
    updateFinishLabel();

    initNecklaceDefaultCount(section);
    initNecklaceVideo(section);
    initNecklaceTimeline(section);

    var tabs = section.querySelectorAll('[data-lp-necklace-how-tab]');
    var panes = section.querySelectorAll('[data-lp-necklace-how-pane]');
    var tabsContainer = tabs.length ? tabs[0].closest('.howitworks-tabs') : null;
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var step = tab.getAttribute('data-step');
        tabs.forEach(function (item) {
          var active = item.getAttribute('data-step') === step;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        panes.forEach(function (pane) {
          pane.classList.toggle('is-active', pane.getAttribute('data-step') === step);
        });
        if (tabsContainer) tabsContainer.classList.add('is-engaged');
      });
    });

    if (tabsContainer && 'IntersectionObserver' in window) {
      var wiggleObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            tabsContainer.classList.add('is-in-view');
            wiggleObserver.disconnect();
          }
        });
      }, { threshold: 0.3 });
      wiggleObserver.observe(tabsContainer);
    }

  }

  function initNecklaceDefaultCount(section) {
    try {
      var url = new URL(window.location.href);
      if (url.searchParams.get('variant')) return;
    } catch (error) {}

    var selector = section.querySelector('[data-lp-necklace-count-selector]');
    if (!selector) return;

    var target = null;
    selector.querySelectorAll('.pendant-btn').forEach(function (button) {
      var value = button.getAttribute('data-lp-option-value') || button.textContent || '';
      if (!target && /\b3\b/.test(value.trim())) target = button;
    });
    if (!target || target.classList.contains('active')) return;
    target.click();
  }

  function initNecklaceVideo(section) {
    var wrap = section.querySelector('[data-lp-necklace-video]');
    if (!wrap || wrap.dataset.lpNecklaceVideoInit) return;
    wrap.dataset.lpNecklaceVideoInit = '1';

    var video = wrap.querySelector('video');
    var muteBtn = wrap.querySelector('[data-lp-necklace-video-mute]');
    var mutedIcon = wrap.querySelector('[data-lp-necklace-video-muted]');
    var soundIcon = wrap.querySelector('[data-lp-necklace-video-sound]');
    var hint = wrap.querySelector('[data-lp-necklace-video-hint]');
    if (!video || !muteBtn) return;

    function setMuted(muted) {
      video.muted = muted;
      if (mutedIcon) mutedIcon.style.display = muted ? '' : 'none';
      if (soundIcon) soundIcon.style.display = muted ? 'none' : '';
      muteBtn.setAttribute('aria-label', muted ? 'Unmute video' : 'Mute video');
      wrap.classList.toggle('is-unmuted', !muted);
    }

    muteBtn.addEventListener('click', function (event) {
      event.stopPropagation();
      setMuted(!video.muted);
      if (video.paused) video.play().catch(function () {});
    });

    wrap.addEventListener('click', function (event) {
      if (event.target.closest('.video-ctrl')) return;
      if (video.paused) {
        video.play().catch(function () {});
      } else {
        video.pause();
      }
    });

    video.addEventListener('play', function () {
      wrap.classList.remove('is-paused');
    });
    video.addEventListener('pause', function () {
      wrap.classList.add('is-paused');
    });

    var userInteracted = false;
    muteBtn.addEventListener('click', function () {
      userInteracted = true;
    });

    if ('IntersectionObserver' in window) {
      var visibilityObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting && !video.paused) {
            video.pause();
          } else if (entry.isIntersecting && video.paused && !userInteracted) {
            video.play().catch(function () {});
          }
        });
      }, { threshold: 0.5 });
      visibilityObserver.observe(video);
    }

    setTimeout(function () {
      if (hint && video.muted) hint.style.opacity = '0';
    }, 8000);
  }

  function initNecklaceTimeline(section) {
    var line = section.querySelector('[data-lp-necklace-timeline-line]');
    var dots = section.querySelectorAll('[data-lp-necklace-timeline-dot]');
    if (!line && !dots.length) return;

    if (!('IntersectionObserver' in window)) {
      if (line) line.classList.add('visible');
      dots.forEach(function (dot) {
        dot.classList.add('visible');
      });
      return;
    }

    if (line) {
      var lineObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            lineObserver.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15 });
      lineObserver.observe(line);
    }

    dots.forEach(function (dot) {
      var dotObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            dotObserver.unobserve(entry.target);
          }
        });
      }, { threshold: 0.5, rootMargin: '0px 0px -40px 0px' });
      dotObserver.observe(dot);
    });
  }

  function initAll(root) {
    (root || document).querySelectorAll('.lp-necklace').forEach(initNecklaceLp);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
